import i18n from "@/config/i18n";
/**
 * 年月日枚举
 */
export const DATA_TYPE = {
    year: "1",
    month: "2",
    day: "3",
};
/**
 * 年月日选择列表
 */
export const DATA_TYPE_LIST = [
    { itemValue: i18n.t("year"), itemKey: DATA_TYPE.year },
    { itemValue: i18n.t("month"), itemKey: DATA_TYPE.month },
    { itemValue: i18n.t("day"), itemKey: DATA_TYPE.day },
];
// 年月日组件用的类型
export const TIME_TYPE_OBJ = {
    1: "yearrange",
    2: "monthrange",
    3: "daterange",
};
/**
 * 昨日、今日、累计枚举
 */
export const DAY_TYPE = {
    yesterday: "1",
    today: "2",
    all: "3",
};
/**
 * 昨日、今日、累计选择列表
 */
export const DAY_TYPE_LIST = [
    { itemValue: i18n.t("yesterday"), itemKey: DAY_TYPE.yesterday },
    { itemValue: i18n.t("today"), itemKey: DAY_TYPE.today },
    { itemValue: i18n.t("allday"), itemKey: DAY_TYPE.all },
];
/**
 * 枪状态 tag 色值
 */
export const GUN_STATUS_COLOR = {
    "0": "warning",
    "1": "blue",
    "2": "error",
    "3": "default",
    "4": "default",
    "7": "success",
    "8": "primary",
    "9": "blue",
};
